export default __webpack_public_path__ + "static/media/map1200.7a136d86.png";